import { motion } from "framer-motion";
import { MANIFESTO } from "@/lib/data";

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative bg-[#0F0F11] py-24 md:py-40 border-t border-white/10"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="flex items-center gap-3 mb-16">
          <span className="font-mono-label text-[10px] text-[#C4A484]">
            004 · Inspired by the Reel
          </span>
          <span className="flex-1 h-px bg-white/10" />
        </div>

        <div className="space-y-12 md:space-y-16 max-w-6xl">
          {MANIFESTO.map((line, i) => (
            <motion.div
              key={i}
              data-testid={`manifesto-line-${i}`}
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, delay: i * 0.1 }}
              viewport={{ once: true, margin: "-10%" }}
              className="grid grid-cols-12 gap-6 md:gap-10 items-start border-l border-[#C4A484]/30 pl-6 md:pl-10"
            >
              <span className="col-span-2 md:col-span-1 font-mono-label text-[10px] text-[#C4A484] pt-2 md:pt-4">
                0{i + 1}
              </span>
              <p className="col-span-10 md:col-span-11 font-heading text-3xl md:text-5xl lg:text-6xl tracking-tighter leading-[1.05] text-[#FDFBF7]">
                {line.split(".").map((chunk, idx, arr) =>
                  chunk.trim() ? (
                    <span key={idx}>
                      {chunk.trim()}
                      {idx < arr.length - 1 && chunk.trim() && (
                        <span className="text-[#C4A484]">.</span>
                      )}
                      {idx < arr.length - 2 && <br />}
                    </span>
                  ) : null
                )}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
